import { RegisterOptions } from 'react-hook-form'

import { t } from '@lingui/macro'

export const getRequiredFieldRule = (): Pick<RegisterOptions, 'required'> => ({
  required: { message: t`The field can't be empty`, value: true },
})
